import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "medexpert-check",
  "use": "medexpert-check-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"medexpert-check\">\r\n<path opacity=\"0.2\" d=\"M15.526 0.707C15.159 0.275 14.612 0 14 0H2C0.895 0 0 0.895 0 2V6.178L5.348 9.998C5.646 10.211 6.055 10.177 6.314 9.918L15.525 0.707H15.526Z\" />\r\n<path d=\"M0 9.25001V14C0 15.105 0.895 16 2 16H14C15.105 16 16 15.105 16 14V3.76801L8.082 11.686C6.959 12.809 5.188 12.956 3.895 12.033L0 9.25101L0 9.25001Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol